import _ from "lodash/fp";
import jp from "jsonpath";
import {createAction} from "redux-actions";
import {query} from "../../utilities/query";
import {isFilled} from "../../utilities/isfilled";

export const createSigntask = Object.assign(data => dispatch => {
  data  = _.cloneDeep(data);
  jp.apply(data, "documents", _.takeWhile(isFilled("title", "content")));

  return dispatch(query(createSigntask)("/api/signtask", "POST", data));
}, {
  success: createAction("signtasks/CREATE_SUCCESS", signtask => ({[signtask.id]: signtask})),
  failure: createAction("signtasks/CREATE_FAILURE")
});